import Lib from 'library'
import { atom } from 'recoil'

//FAQ
export const showFaqLayerState = atom({
	key: "showFaqLayerState",
	default: false
})

//알림 설정
export const showAlarmLayerState = atom({
	key: "showAlarmLayerState",
	default: false
})

//이벤트
export const showEventLayerState = atom({
	key: "showEventLayerState",
	default: false
})

//이벤트 상세화면(배너)
export const showEventDetailLayerState = atom({
	key: "showEventDetailLayerState",
	default: false
})

//공지사항
export const showNoticeLayerState = atom({
	key: "showNoticeLayerState",
	default: false
})

//앱버전
export const showAppVerLayerState = atom({
	key: "showAppVerLayerState",
	default: false
})

//약관
export const showTermsAgreeLayerState = atom({
	key: "showTermsAgreeLayerState",
	default: false
})

//약관 상세 화면
export const showTermsAgreeDetailLayerState = atom({
	key: "showTermsAgreeDetailLayerState",
	default: false
})

//약관 상세 내용 화면
export const showTermsAgreeDetailContentsLayerState = atom({
	key: "showTermsAgreeDetailContentsLayerState",
	default: false
})

//문의하기
export const showQuestionLayerState = atom({
	key: "showQuestionLayerState",
	default: false
})

//문의하기
export const moreQuestPost = atom({
	key: "moreQuestPost",
	default: 1
});

//공지사항 
export const moreNoticePost = atom({
	key: "moreNoticePost",
	default: 1
});

//이벤트 
export const moreEventPost = atom({
	key: "moreEventPost",
	default: 1
});

//알림 (메인)
export const moreAlertPost = atom({
	key: "moreAlertPost",
	default: 1
});

// 검색된 기관
export const searchDataState = atom({
	key: "searchDataState",
	default: ""
})

//푸쉬
export const pushDataState = atom({
	key: "pushDataState",
	default: null
})